import React, { useState, useEffect } from "react";
import { TextField } from "@mui/material";
import { Button, Col, FormControl, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import ApiWallet from "../../../../core/api/api.wallet";
import SplitNumber from "../../_Components/SplitNumber";
import _ from "lodash";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ApiUserPayment from "../../../../core/api/api.userPayment";
import { IconWalletCharge } from "../../../../_metronic/css/icons";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import bankArray from "./bankArray";

const RechargeWallet = () => {
  const env = process.env;
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
    setError,
    clearErrors,
  } = useForm({});
  const [riallBalance, setRiallBalance] = useState(0);
  const [loadingData, setLoadingData] = useState(true);
  const [portalList, setPortalList] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        setLoadingData(true);
        const resultApiWallet = await ApiWallet.getAgentWalletByUserId(); // موجودی کیف پول
        setRiallBalance(resultApiWallet?.data?.riallBalance);

        // دریافت لیست درگاه ها
        const response = await ApiUserPayment.getActivePortalList({});
        setPortalList(response.data);
      } catch (error) {
        console.log("error :>> ", error);
      } finally {
        setLoadingData(false);
      }
    })();
  }, []);
  const validateNumberAmount = (value) => {
    if (
      Number(value) > 2147483647 ||
      value.includes(".") ||
      value.includes("-")
    ) {
      setError("amount", {
        type: "manual",
        message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد.",
      });
      return false;
    } else {
      clearErrors("amount");
      return true;
    }
  };
  const onSubmit2 = async (data) => {
    try {
      data.amount = data.amount.split(" ").join("").split(",").join("");
      //   ارسال به درگاه
      const response = await ApiUserPayment.insertPayment({
        rialAmount: parseInt(data.amount),
        userPaymentTypeId: data.userPaymentTypeId,
      });
      if (!_.isEmpty(response)) {
        toast(response.message);
        if (
          response.data.message === "CreateLinkeOk" &&
          response.data.basketPaymentStatusId === 1
        )
          window.location.replace(
            env.REACT_APP_API_URL + "home?redirectId=" + response.data.link
          );
        else if (response.data.Link === "") {
          toast(response.data.message);
        }
      }
    } catch (error) {}
  };

  return (
    <div>
      <ToastContainer rtl="true"></ToastContainer>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header  pb-3 pt-5 mb-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">
              شارژ کیف پول
            </span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm"></span>
          </h3>
          <div className="card-toolbar">
            {/* <Link variant="success" className="btn btn-success"
                    key={0}
                    to={{
                        pathname: "/agentAccount/0",
                        state: { newAgentAccount: true }
                    }}
                >
                    درج حساب جدید
                </Link> */}
          </div>
        </div>
        {/*Start body */}
        <div className="card-body">
          <Row className="pb-5">
            <Col xs="12" md="6" lg="auto">
              <div
                className="mb-3 border rounded-4 h-100 bg-light d-flex align-items-center justify-content-center flex-column
          p-5"
                style={{ minWidth: "230px" }}
              >
                <div>
                  <IconWalletCharge width={36} />
                  <span className="pl-2" style={{ fontSize: "16px" }}>
                    اعتبار کیف پول
                  </span>
                </div>
                <div
                  className="fw-bold px-3 mt-3 text-center"
                  style={{ fontSize: "18px" }}
                >
                  {" "}
                  <SplitNumber number={riallBalance} />
                </div>
              </div>
            </Col>
            <Col xs="12" md="auto" lg="auto" className="d-none d-md-block">
              <div
                className="border-right"
                style={{ width: "3px", height: "100%" }}
              ></div>
            </Col>
            <Col xs="12" md="5" lg>
              <div className="pt-3">
                جهت شارژ کیف پول خود، مبلغ و درگاه بانکی را انتخاب نمایید.{" "}
              </div>
              <form onSubmit={handleSubmit(onSubmit2)}>
                <Row>
                  <Col xs="12" md="12" className="px-0">
                    <Col xs="12">
                      <Controller
                        name="amount"
                        control={control}
                        rules={{
                          required: "مبلغ الزامی است",
                          validate: (value) =>
                            value > 0 || "مبلغ باید بیشتر از صفر باشد",
                        }}
                        render={({
                          field: { onChange, value },
                          fieldState: { error },
                        }) => (
                          <NumericFormat
                            customInput={TextField}
                            label="مبلغ به تومان"
                            size="small"
                            margin="normal"
                            value={value || ""}
                            variant="outlined"
                            thousandSeparator=","
                            decimalScale="0"
                            //prefix=" تومان "
                            error={!!errors.amount}
                            onValueChange={(values) => {
                              onChange(values.value || "");
                              validateNumberAmount(values.value);
                            }}
                            //onChange={(e) => onChange(e.target.value)}
                            autoFocus
                          />
                        )}
                      />
                      {errors.amount && (
                        <div className="text-small-1 text-danger">
                          {" "}
                          {errors.amount.message}
                        </div>
                      )}
                    </Col>

                    <Col xs={12}>
                      {loadingData ? (
                        <div
                          style={{ border: "1px solid #ccc" }}
                          className={
                            "mb-2  rounded-2 p-3 d-flex align-items-center"
                          }
                        >
                          <div className="pl-2 d-flex align-items-center">
                            <input
                              type="radio"
                              name="userPaymentTypeId"
                              className="option-input radio "
                            />
                          </div>
                          <div className="pl-3 fw-bold">
                            <Skeleton width="40px" height="15px"></Skeleton>
                          </div>
                        </div>
                      ) : (
                        portalList?.map((item, index) => (
                          <div
                            key={index}
                            style={{ border: "1px solid #ccc" }}
                            className={
                              "mb-2  rounded-2 p-3 d-flex align-items-center"
                            }
                          >
                            <div className="pl-2 d-flex align-items-center">
                              <input
                                {...register("userPaymentTypeId")}
                                type="radio"
                                name="userPaymentTypeId"
                                value={item.id}
                                id="field-rain"
                                className="option-input radio "
                                defaultChecked={index == 0}
                              />
                            </div>
                            <div className="pl-3 fw-bold">
                              <label for="userPaymentTypeId" className="mb-0">
                                {item.titleShow}
                              </label>
                            </div>
                          </div>
                        ))
                      )}
                    </Col>

                    <Col xs="12">
                      <Button
                        type="submit"
                        variant="success"
                        className="w-100"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? "در حال انتقال..." : "انتقال به درگاه"}
                      </Button>
                    </Col>
                  </Col>
                </Row>
              </form>
            </Col>
            <Col xs="12" lg>
              <div className="border rounded-4">
                <div className="bg-gray p-2 rounded-3 my-3">
                  <div className=" my-2 pl-4  mb-3 pb-2">
                    {/* <ExclamationCircle size={15} className="text-muted ml-1" /> */}
                    <span className="">
                      قابل پرداخت توسط تمامی کارت های بانکی{" "}
                    </span>
                  </div>
                  {bankArray.map((bank, key) => {
                    return (
                      <button
                        key={key}
                        className="btn-sm btn-no-style py-1 mx-1 my-1 bg-white text-dark border-0"
                        type="submit"
                        disabled={isSubmitting}
                      >
                        <img src={bank.imgPath} width={25} height={25} />
                      </button>
                    );
                  })}
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default RechargeWallet;
